import config from '../config'
import { queryClosestParent } from './html'


/**
 * Lazyload Callbacks
 *
 */
const lazyImageLoad = (e) => {
    const $img = e.currentTarget;
    const $parent = queryClosestParent($img, `.${config.CSS_CLASS.IMAGE}`);

    requestAnimationFrame(() => {
        if ($parent) {
            $parent.classList.remove(config.CSS_CLASS.IMAGE_LAZY_LOADING);
            $parent.classList.add(config.CSS_CLASS.IMAGE_LAZY_LOADED);
        }

        $img.classList.add(config.CSS_CLASS.IMAGE_LAZY_LOADED);
    });
};

const lazyImageError = (e) => {
    const $img = e.currentTarget;
    const $parent = queryClosestParent($img, `.${config.CSS_CLASS.IMAGE}`);

    requestAnimationFrame(() => {
        if ($parent) {
            $parent.classList.remove(config.CSS_CLASS.IMAGE_LAZY_LOADING);
            $parent.classList.add(config.CSS_CLASS.IMAGE_LAZY_ERROR);
        }
    });
};

/* Trigger Lazyload Callbacks */
const triggerLazyloadCallbacks = ($lazyImagesArgs) => {
    const $lazyImages = $lazyImagesArgs
        ? $lazyImagesArgs
        : document.querySelectorAll('[loading="lazy"]');

    if ("loading" in HTMLImageElement.prototype) {
        for (const $img of $lazyImages) {
            const $parent = queryClosestParent(
                $img,
                `.${config.CSS_CLASS.IMAGE}`
            );

            if (!$img.complete) {
                $parent?.classList.add(
                    config.CSS_CLASS.IMAGE_LAZY_LOADING
                );
                $img.addEventListener("load", lazyImageLoad, { once: true });
                $img.addEventListener("error", lazyImageError, { once: true });
            } else {
                $parent?.classList.add(
                    config.CSS_CLASS.IMAGE_LAZY_LOADED
                );

                $img.classList.add(config.CSS_CLASS.IMAGE_LAZY_LOADED);
            }
        }
    } else {
        // if 'loading' supported
        for (const $img of $lazyImages) {
            const $parent = queryClosestParent(
                $img,
                `.${config.CSS_CLASS.IMAGE}`
            );
            $parent.classList.add(config.CSS_CLASS.IMAGE_LAZY_LOADED);
        }
    }
};

/* Reset Lazyload Callbacks */
const resetLazyloadCallbacks = () => {
    if ("loading" in HTMLImageElement.prototype) {
        const $lazyImages = document.querySelectorAll('[loading="lazy"]');
        for (const $img of $lazyImages) {
            $img.removeEventListener("load", lazyImageLoad, { once: true });
            $img.removeEventListener("error", lazyImageError, { once: true });
        }
    }
};


export {
    triggerLazyloadCallbacks,
    resetLazyloadCallbacks
}
